const getUpdatedAtTimestamp = shipment => {
    const value = shipment && (shipment.updated_at || shipment.updatedAt);
    const timestamp = value ? new Date(value).getTime() : NaN;

    return Number.isFinite(timestamp) ? timestamp : null;
};

const getTrackingDetailsCount = shipment => {
    const routeDrivers = shipment && shipment.Route && Array.isArray(shipment.Route.RouteDrivers)
        ? shipment.Route.RouteDrivers
        : [];
    const trackingDetails = routeDrivers[0] && routeDrivers[0].tracking_blob
        ? routeDrivers[0].tracking_blob.trackingDetails
        : null;

    return Array.isArray(trackingDetails) ? trackingDetails.length : 0;
};

export const sortTrackingPointsChronologically = trackingPoints => {
    if (!Array.isArray(trackingPoints)) {
        return [];
    }

    return [...trackingPoints].sort((left, right) => {
        const leftTimestamp = new Date((left && (left.timestamp || left.time)) || 0).getTime();
        const rightTimestamp = new Date((right && (right.timestamp || right.time)) || 0).getTime();
        const normalizedLeftTimestamp = Number.isFinite(leftTimestamp) ? leftTimestamp : 0;
        const normalizedRightTimestamp = Number.isFinite(rightTimestamp) ? rightTimestamp : 0;

        return normalizedLeftTimestamp - normalizedRightTimestamp;
    });
};

export const preferFreshShipmentWithTrackingHistory = (existingShipment, candidateShipment) => {
    if (!existingShipment) {
        return candidateShipment;
    }

    if (!candidateShipment) {
        return existingShipment;
    }

    const existingUpdatedAt = getUpdatedAtTimestamp(existingShipment);
    const candidateUpdatedAt = getUpdatedAtTimestamp(candidateShipment);
    const candidateIsNewer = candidateUpdatedAt != null
        && (existingUpdatedAt == null || candidateUpdatedAt > existingUpdatedAt);
    const existingIsNewer = existingUpdatedAt != null
        && (candidateUpdatedAt == null || existingUpdatedAt > candidateUpdatedAt);
    const candidateLocationUpdateCount = Array.isArray(candidateShipment.LocationUpdates) ? candidateShipment.LocationUpdates.length : 0;
    const existingLocationUpdateCount = Array.isArray(existingShipment.LocationUpdates) ? existingShipment.LocationUpdates.length : 0;
    const candidateTrackingDetailsCount = getTrackingDetailsCount(candidateShipment);
    const existingTrackingDetailsCount = getTrackingDetailsCount(existingShipment);
    const candidateHasMoreTracking = candidateLocationUpdateCount > existingLocationUpdateCount
        || candidateTrackingDetailsCount > existingTrackingDetailsCount;

    if (!candidateIsNewer && !existingIsNewer && !candidateHasMoreTracking) {
        return existingShipment;
    }

    const freshShipment = candidateIsNewer ? candidateShipment : existingShipment;
    const staleShipment = candidateIsNewer ? existingShipment : candidateShipment;

    return {
        ...staleShipment,
        ...freshShipment,
        Orders: Array.isArray(freshShipment.Orders) && freshShipment.Orders.length > 0 ? freshShipment.Orders : staleShipment.Orders,
        Route: freshShipment.Route || staleShipment.Route,
        LocationUpdates: candidateLocationUpdateCount > existingLocationUpdateCount
            ? candidateShipment.LocationUpdates
            : existingShipment.LocationUpdates,
        ShipmentHandshakes: Array.isArray(freshShipment.ShipmentHandshakes) && freshShipment.ShipmentHandshakes.length > 0
            ? freshShipment.ShipmentHandshakes
            : staleShipment.ShipmentHandshakes,
    };
};